'use es6';

import { combineReducers } from 'redux';
export default combineReducers({});